import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {HttpService} from '../../../../core';
import {finalize} from 'rxjs/operators';

@Component({
  selector: 'app-welcome-dialog',
  templateUrl: './welcome-dialog.component.html',
  styleUrls: ['./welcome-dialog.component.scss']
})
export class WelcomeDialogComponent implements OnInit {
  formGroup!: FormGroup;
  companyId: any;
  isLoading = false;

  constructor(private dialogRef: MatDialogRef<WelcomeDialogComponent>,
              private dialog: MatDialog,
              private fb: FormBuilder,
              private toast: ToastrService,
              private httpService: HttpService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.formGroup = this.fb.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      companyName: [''],
      abn: ['']
    });
  }

  ngOnInit(): void {
    console.log('---data---', this.data);
    this.companyId = this.data.record;
  }

  onClose() {
    this.dialog.closeAll();
  }

  onSubmit() {
    if (this.formGroup.invalid) {
      this.toast.error('Please fill in all required fields', 'Error');
      return;
    }
    this.isLoading = true;
    const fdUser = new FormData();
    fdUser.append('firstName', this.formGroup.value.firstName);
    fdUser.append('lastName', this.formGroup.value.lastName);
    this.httpService.editUser(fdUser)
      .pipe(finalize(() => this.isLoading = false))
      .subscribe(res =>
        this.handelResponseUser(res));
  }

  handelResponseUser(res: any) {
    if (res.code === 1) {
      if (this.formGroup.value.companyName || this.formGroup.value.abn) {
        this.isLoading = true;
        const fdCompany = new FormData();
        fdCompany.append('name', this.formGroup.value.companyName);
        fdCompany.append('abn', this.formGroup.value.abn);
        this.httpService.editCompanyInfo(fdCompany, this.companyId)
          .pipe(finalize(() => this.isLoading = false))
          .subscribe(result =>
            this.handelResponseCompany(result));
      } else {
        this.onClose();
        this.dialogRef.close();
      }
    } else {
      this.toast.error('Error', 'Please try again later');
    }
  }

  handelResponseCompany(res: any) {
    if (res.code === 1) {
      this.onClose();
      this.dialogRef.close(this.data);
    } else {
      this.toast.error('Error', 'Please try again later');
    }
  }
}
